export function adjustedCalendarWidth() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (typeof width !== 'undefined' && width < 375) {
        return (width - 30) / 7;
    }
    return 50;
}
